<h2 mat-dialog-title class="dialog_title">
    <span (click)="log()">
        {{ "AI generation settings" | translate }}
    </span>
    <button class="ml-1" mat-icon-button (click)="close()">
        <mat-icon>close</mat-icon>
    </button>
</h2>
<mat-dialog-content class="mat-typography extra_info">
    <div class="container form_wrapper">
        <mat-form-field appearance="outline" class="full_width_form">
            <mat-label>{{ "AI model" | translate }}</mat-label>
            <mat-select [disableOptionCentering]="true" [multiple]="false" selectDir [formControl]="data.ai_model">
                <mat-select-trigger *ngIf="data.ai_model.value">
                    {{getModelById(data.ai_model.value)?.name}}
                </mat-select-trigger>
                <mat-option>
                    <ngx-mat-select-search 
                        placeholderLabel="{{ 'Search' | translate }}" 
                        noEntriesFoundLabel="{{ 'no matching model found' | translate }}"
                        [formControl]="aiModelControl"></ngx-mat-select-search>
                </mat-option>
                <ng-container *ngFor="let model of models$ | async">
                    <mat-option [value]="model.id">
                    <div class="d-f-c" style="justify-content: space-between;">
                        {{model.name}}
                        <div class="d-f-c">
                            <div class="ai-icon" *ngIf="model?.is_image_input">
                                <mat-icon class="ai-main">crop_original</mat-icon>
                                <mat-icon class="ai-small top-right">expand_circle_down</mat-icon>
                            </div>
                            <div class="ai-point" *ngIf="model?.is_web_search"></div>
                        </div>
                    </div>
                    </mat-option>
                </ng-container>
            </mat-select>
        </mat-form-field>

        <div class="box_wrp">
            <mat-checkbox color="primary" [formControl]="data.withFrames">{{"Use existing frames in generation?" | translate}}</mat-checkbox>
        </div>

        <ng-container *ngIf="!data?.file">
            <p>{{"Generation will be based in image" | translate}}:</p>

            <ng-container *ngFor="let item of data.cards; let i = index;">
                <ng-container *ngFor="let file of item.files">
                    <div class="images">
                        <div class="img">
                            <img (error)="onImgError($event)" style="max-width: 100%; max-height: 100%;" [src]="data?.host + file.thumbnail + '?company_id=' + data?.company?.id">
                        </div>
                        <ng-container *ngIf="file.frames && file.frames.length && data.withFrames.value">
                            <div class="img" *ngFor="let frame of file.frames" #tooltip="matTooltip" matTooltip="{{ 'Ai frame ' + (frame?.time | veTime) }}" [matTooltipPosition]="'above'">
                                <img style="max-width: 100%; max-height: 100%;" [src]="!!frame?.uploadedFile ? (data?.host + frame?.uploadedFile?.original + '?company_id=' + data?.company?.id) : frame?.blobSrc" alt="">
                            </div>
                        </ng-container>
                    </div>
                </ng-container>
                
            </ng-container>

        </ng-container>

        <ng-container *ngIf="!!data?.file">
            <p>{{"Generation will be based in image" | translate}}:</p>

            <div class="images">
                <div class="img">
                    <img (error)="onImgError($event)" style="max-width: 100%; max-height: 100%;" [src]="data?.host + data?.file?.thumbnail + '?company_id=' + data?.company?.id">
                </div>
                <ng-container *ngIf="data?.file?.frames && data?.file?.frames.length && data.withFrames.value">
                    <div class="img" *ngFor="let frame of data?.file?.frames" #tooltip="matTooltip" matTooltip="{{ 'Ai frame ' + (frame?.time | veTime) }}" [matTooltipPosition]="'above'">
                        <img style="max-width: 100%; max-height: 100%;" [src]="!!frame?.uploadedFile ? (data?.host + frame?.uploadedFile?.original + '?company_id=' + data?.company?.id) : frame?.blobSrc" alt="">
                    </div>
                </ng-container>
            </div>
        </ng-container>

        <ng-container *ngIf="!!data.withFrames.value && !data?.file">
            <div class="box_wrp" style="margin-top: 20px;">
                <mat-checkbox color="primary" [formControl]="data.isCreateFrames">{{"Create new frames for all video files" | translate}}</mat-checkbox>
            </div>

            <mat-form-field appearance="outline" class="full_width_form" *ngIf="icludesVideo() && data.isCreateFrames.value">
                <mat-label>{{ "AI frames" | translate }}</mat-label>
                <mat-select [disableOptionCentering]="true" [multiple]="false" selectDir [formControl]="data.ai_frames">
                    <mat-option [value]="1">
                        1
                    </mat-option>
                    <mat-option [value]="2">
                        2
                    </mat-option>
                    <mat-option [value]="3">
                        3
                    </mat-option>
                    <mat-option [value]="4">
                        4
                    </mat-option>
                    <mat-option [value]="5">
                        5
                    </mat-option>
                    <mat-option [value]="6">
                        6
                    </mat-option>
                    <mat-option [value]="7">
                        7
                    </mat-option>
                    <mat-option [value]="8">
                        8
                    </mat-option>
                    <mat-option [value]="9">
                        9
                    </mat-option>
                    <mat-option [value]="10">
                        10
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </ng-container>
            

        <mat-form-field appearance="outline" class="full_width_form" style="margin-top: 20px;">
            <mat-label>{{ 'AI info' | translate }}</mat-label>
            <textarea 
            cdkTextareaAutosize
            #autosize="cdkTextareaAutosize"
            cdkAutosizeMinRows="3"
            cdkAutosizeMaxRows="12" [formControl]="data.cstPrompt" matInput placeholder="{{ 'AI info' | translate }}"></textarea>
        </mat-form-field>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <div class="d-f-c">
        <button mat-button (click)="close()">
            {{ "Close" | translate }}
        </button>
        <button class="ml-1 d-f-btn" (click)="createFrames()" mat-stroked-button [disabled]="isCreateFramesStart" *ngIf="!data?.file && !isCreateFramesHide && !!data.withFrames.value && data.isCreateFrames.value">
            <mat-spinner class="spin_16 mr-1" *ngIf="isCreateFramesStart"></mat-spinner>  
             {{ "Create New Frames" | translate }}
        </button>
        <button class="ml-1" (click)="generate()" mat-raised-button cdkFocusInitial color="primary" *ngIf="isCreateFramesStart || !data.isCreateFrames.value || !!data?.file">
            {{ "Generate Titles And Descriptions" | translate }}
        </button>
    </div>
</mat-dialog-actions>

